/**
 * @copyright 2015, Andrey Popp <8mayday@gmail.com>
 */

'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequire(obj) { return obj && obj.__esModule ? obj['default'] : obj; }

require('font-awesome/css/font-awesome.css');

var _Icon = require('./Icon');

exports['default'] = _interopRequire(_Icon);
module.exports = exports['default'];



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-fa/lib/index.js
 ** module id = 77
 ** module chunks = 0
 **/